module.exports = __webpack_public_path__ + "img/sameah_no.62740627.png";